export var FocusElement;
(function (FocusElement) {
    FocusElement[FocusElement["LimitPrice"] = 0] = "LimitPrice";
    FocusElement[FocusElement["StopPrice"] = 1] = "StopPrice";
    FocusElement[FocusElement["Quantity"] = 2] = "Quantity";
    FocusElement[FocusElement["StopLoss"] = 3] = "StopLoss";
    FocusElement[FocusElement["TakeProfit"] = 4] = "TakeProfit";
    FocusElement[FocusElement["ProductType"] = 5] = "ProductType";
})(FocusElement || (FocusElement = {}));
